module.exports = __webpack_public_path__ + "img/位图(2).8bd2feff.png";